import QdtComponents from 'qdt-components';

const options = {
  config: {
    host: 'qap.ipc-global.com',
    appId: '36f57957-352f-4b0d-8680-00b5eec221b6',
    // appId: '6930b461-9a5d-4890-af66-b52f7d6420ad',
    secure: true,
    port: 443,
    prefix: '',
  },
  connections: {
    vizApi: true,
    engineApi: true,
  },
};

const qdtComponents = new QdtComponents(options.config, options.connections);

export { qdtComponents, options };

